var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyLifeInsuranceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8645",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8645",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACfklEQVR4nO2cu24UMRiFjyEPwSulpIQukZCo4X14NGhSoIQCHoAcGhfLJLOei3/7jOd80ja79n/xJ+9IcwOMMcYYY4wxxhhjjDHGmCIkv5L8w8r07iuKFBmc5DsADwDe1o6dUgqtvRdvBskxDKGLlVL6CeALgN+ReUwDSN6R/Hu2Y4gkJRkW0hCS96/IeCGnd52nYGZnPJP8bCGNuSYj/95EyLW/yQii+tgFCzLymCaNtJDQoo/NcIGMPK5JIy0ktOhjE1woI49t0kgLCS36WA1XyMjjmzQSnUdSyFoZeY6FRLBFRp5nIQHFbJKR51pI5UI2y8jzLaRiEbtk5BgWUqmA3TJyHAupkLyKjBzLQnYmriYjx/txEed77Xov8ownhPOn0O93xLwl+ZA/tzXrneQZS0jtndGaoYQcXQYwkJARZACDCBlFBjCAkJFkAAcXMpoM4MBCRpQBHFTIqDKAAwoZWQZwMCGjywAOJOQMMoCDCDmLDOAAQlrLmBYcTSl/dH9rJzffGTHLPk8pf3R/ayZ2+ZuKWfZ5Svmj+1s6qdsxI2bZ5ynlj+5vyYSPrHxxaQ29F6R3/ungRPJXLxm5hlMLee2hz8tBzwA+pZS+1S7MLITke5JPJB9JfuiQ/9Q7RO7h+2mRtV8QUIrfO78f6hfDQsSwEDEsRAwLEcNCxLAQMSxEDAsRw0LEsBAxLEQMCxHjZvpFxCnna4z6uteteIeIYSFiWIgYL44hU6KvmJn/8Q4Rw0LEsBAxLEQMCxHDQsSwEDEsRAwLEcNCxLAQMSxEDAsRw0LEsBAxLEQMCxHDQsSwEDEsRAwLEaN410nvu0TOlt87RAwLEcNCxPgHNC3S4DaN1tcAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyLifeInsuranceIcon);
export default __webpack_public_path__ + "static/media/BuyLifeInsuranceIcon.5fc6c31098590d3005deb3511b0b9965.svg";
export { ForwardRef as ReactComponent };